import { CONSTRUCTOR } from '..';

// CreateActivityResponse field fragment.
export const createActivityResponse = CONSTRUCTOR.FRAGMENT({
  name: 'CreateActivityResponse',
  fields: `{
    id
  }`,
});
